import React from 'react';
import {Link, } from 'react-router-dom';
import { useAuth } from '../context';

const Profile = () => {
    const { user  } = useAuth();
    // const navigate = useNavigate();

    // const onLogout = () => {
    //     logout();
    //     navigate('/', { replace: true });
    // };

    return (

        <div style={{ maxWidth: 600, margin: '40px auto', padding: 24 }}>

            <h2 style={{ marginTop: 0 }}>My Profile</h2>
            <div style={{ padding: 16, border: '1px solid #ddd', borderRadius: 8 }}>
                {user?.image_url && (
                    <div style={{ marginBottom: 16 }}>
                        <img src={user.image_url} alt="Profile" style={{ width: 100, height: 100, borderRadius: '50%', objectFit: 'cover' }} />
                    </div>
                )}
                <p><strong>Name:</strong> {user?.name}</p>
                <p><strong>Email:</strong> {user?.email}</p>
            </div>
            <div style={{ marginTop: 16 }}>
                <Link to="/account/profile/edit" className="btn btn-primary">Edit Profile</Link>
            </div>
            <div className="address-book__footer">
                <Link to="/account" className="btn btn-link">Back to Account</Link>
            </div>
        </div>
    );
}


export default Profile;
